import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import TransferServices from '../../services/TransferServices';
export default function ViewBeneficiary() {
  
    const [users, setUser] = useState({});

    const name = new URLSearchParams(window.location.search).get("id");
    const viewDetails = async () => {
        const user = await TransferServices.viewBeneficiary(name);
        setUser(user.data)
    }
 
    useEffect(() => {
        viewDetails();
    }, [])
    return (
        <>
            <Layout pageTag={'transfers'} current={'/beneficiary/view'}>
                <React.Fragment>
                    <main>
                        <div className='py-6'>
                            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                <h1 className="text-2xl font-semibold text-gray-900">Beneficiary Details</h1>
                            </div>
                        </div>
                        <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                            <div className=''>
                                <div className="px-4 sm:px-6 lg:px-8">

                                  
                                    <div className="mt-8 flex flex-col">
                                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                                                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                    <div className=''>
                                                        <div className='inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                            {/* form */}
                                                            <form className='px-6'>
                                                                <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                                    <div className="sm:col-span-3">
                                                                        <label htmlFor="firstname" className="block text-sm font-medium text-gray-700">
                                                                            First name
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input type="text" name="firstname" id="firstname" value={users.firstName} autocomplete="given-name" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="sm:col-span-3">
                                                                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                                                            Last name
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input type="text" name="lastName" id="lastName" value={users.surname} autocomplete="given-name" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        </div>
                                                                    </div>

                                                                    <div className="sm:col-span-2">
                                                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                                                            Email
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input type="email" name="email" id="email" value={users.emailAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        </div>
                                                                    </div>

                                                                    <div className="sm:col-span-2">
                                                                        <label htmlFor="branch" className="block text-sm font-medium text-gray-700">
                                                                            Branch
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input type="text" name="branch" id="branch" value={users.branchName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        </div>
                                                                    </div>

                                                                    <div className="sm:col-span-2">
                                                                        <label htmlFor="role" className="block text-sm font-medium text-gray-700">
                                                                            Role
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input type="text" name="role" id="role" value={users.roleName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                              
                                                            </form>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </main>
                </React.Fragment>
            </Layout>

        </>
    );
}